import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import { useMemo } from 'react';
import format from 'date-fns/format';
import get from 'lodash/get';
import { API_VERSION, API_URL } from './constants';
import { cacheBustURL, postAndCache, postData, replaceCacheURL, usePost } from '../fetch';
import { mapFiltersToArray } from './utils';
export function getReportManifestURL(_ref) {
  var accountId = _ref.accountId,
      reportId = _ref.reportId;
  return "".concat(API_URL, "/v").concat(API_VERSION, "/manifest/").concat(accountId, "/report/").concat(reportId);
}
export function getReportPostBody(_ref2) {
  var _ref2$activeFilters = _ref2.activeFilters,
      activeFilters = _ref2$activeFilters === void 0 ? [] : _ref2$activeFilters,
      dateRange = _ref2.dateRange,
      _ref2$manifest = _ref2.manifest,
      manifest = _ref2$manifest === void 0 ? true : _ref2$manifest;
  var startDate = get(dateRange, 'startDate', null) ? format(dateRange.startDate, 'MM-dd-yyyy') : null;
  var endDate = get(dateRange, 'endDate', null) ? format(dateRange.endDate, 'MM-dd-yyyy') : null;
  return {
    activeFilters: mapFiltersToArray(activeFilters),
    startDate: startDate,
    endDate: endDate,
    alwaysManifest: manifest
  };
} // use this to cache a report before you use it (to avoid rendering a loading state for it)

export function cacheReport(_x, _x2) {
  return _cacheReport.apply(this, arguments);
} // use this to cache bust a report

function _cacheReport() {
  _cacheReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, force) {
    var url, postBody;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = getReportManifestURL(params);
            postBody = getReportPostBody(params);
            _context.next = 4;
            return postAndCache(url, postBody, 'cacheReport', force);

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _cacheReport.apply(this, arguments);
}

export function cacheBustReport(params) {
  var url = getReportManifestURL(params);
  cacheBustURL(url);
} // use this to fetch a report for editing without triggering any loading states

export function fetchReport(_x3) {
  return _fetchReport.apply(this, arguments);
} // use this to replace a report in the cache with a modified version

function _fetchReport() {
  _fetchReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var url, postBody;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = getReportManifestURL(params);
            postBody = getReportPostBody(params);
            _context2.next = 4;
            return postData(url, JSON.stringify(postBody));

          case 4:
            return _context2.abrupt("return", _context2.sent);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchReport.apply(this, arguments);
}

export function replaceCacheReport(params) {
  var url = getReportManifestURL(params);
  var postBody = getReportPostBody(params);
  replaceCacheURL(url, postBody, params.report);
} // use this function to actually use the report data from a React component w/suspense loading state

export function useReport(_ref3) {
  var accountId = _ref3.accountId,
      activeFilters = _ref3.activeFilters,
      reportId = _ref3.reportId,
      dateRange = _ref3.dateRange,
      manifest = _ref3.manifest;
  var url = getReportManifestURL({
    accountId: accountId,
    reportId: reportId
  });
  var postBody = useMemo(function () {
    return getReportPostBody({
      activeFilters: activeFilters,
      dateRange: dateRange,
      manifest: manifest
    });
  }, [activeFilters, dateRange, manifest]);
  return usePost(url, postBody, 'useReport');
}
export default useReport;